<div class="email-head-conatiner">
  @if (isShowHeader) {
  <div class="flex justify-content-between align-items-center">
    <div class="inline-flex align-items-center gap-1">
      <app-avatar [data]="headerData"></app-avatar>
      <span class="text-sm font-semibold">
        <{{ from | lowercase }}>
      </span>
    </div>
    <div>
      <div class="text-sm text-gray-700 min-w-max">
        {{ date | date : "dd MMM yyyy, hh:mm a" }}
      </div>
    </div>
  </div>
  }
  <div class="email-head-info mt-2 ml-2 flex justify-content-between align-items-start">
    <div>
      <div class="text-sm text-gray-700 flex gap-2">
        <span class="text-gray-800 font-semibold"> To: </span>
        <div class="flex flex-wrap">
          <span> {{ to[0] | lowercase }};&nbsp; </span>
          @if (!isToShow && to.length > 1) {
          <span class="text-gray-700 cursor-pointer" (click)="isToShow = true"
            >&nbsp; +{{ to.length - 1 }}more
          </span>
          }@else { @for (item of to; track $index) { @if ($index>0) {
          <span>{{ item | lowercase }};&nbsp;</span>
          } } }
        </div>
      </div>
      @if (cc.length > 0) {
      <div class="text-sm text-gray-700 flex gap-2">
        <span class="text-gray-800 font-semibold"> Cc: </span>
        <div class="flex flex-wrap">
          <span> {{ cc[0] | lowercase }};&nbsp; </span>
          @if (!isCCShow && cc.length > 1) {
          <span class="text-gray-700 cursor-pointer" (click)="isCCShow = true"
            >&nbsp; +{{ cc.length - 1 }}more
          </span>
          }@else { @for (item of cc; track $index) { @if ($index>0) {
          <span>{{ item | lowercase }};&nbsp;</span>
          } } }
        </div>
      </div>
      }
      <!--<div class="w-full flex align-items-center">
        <div class="text-sm text-gray-700 flex align-items-center gap-2 subject">
          <span class="text-gray-800 font-semibold"> Subject: </span>
          <span class="subject-ellipsis" title="{{ subject }}">
            {{ subject }}
          </span>
          <span>
            <app-copy-content title="subject" [content]="subject"></app-copy-content>
          </span>
        </div>
      </div>-->
    </div>
    <div>
      <app-toolbar [toolbar]="toolbar" (openEmailInfoEvent)="openEmailInfo($event)"></app-toolbar>
    </div>
  </div>
</div>

<p-confirmPopup #confirmPopupRef key="emailInfoPopup" appendTo="body">
  <ng-template pTemplate="headless">
    <div>
      <app-email-info [headerData]="headerData"/>
    </div>
  </ng-template>
</p-confirmPopup>
